import { UserNotificationService } from '@core/modules/user-notification/user-notification.service';
import { LiveValueService } from '@core/services/live-value.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProcessImageComponent } from './process-image.component';
import { SprintfPipe } from './pipes/sprintf.pipe';
import { PortalModule } from '@angular/cdk/portal';
import { DistributedLiveValuesService } from './services/distributed-live-values.service';
import { ProcessImageRendererService } from './services/process-image-renderer.service';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { TranslationModule } from '@core/modules/translation/translation.module';
import { ProcessImageService } from '@core/components/process-image/services/process-image.service';

@NgModule({
  imports: [CommonModule, TranslationModule, PortalModule],
  declarations: [ProcessImageComponent, SprintfPipe, SafeHtmlPipe],
  providers: [
    // Pipes
    SprintfPipe,

    // Services
    DistributedLiveValuesService,
    ProcessImageRendererService,
    LiveValueService,
    UserNotificationService,
    ProcessImageService
  ],
  exports: [ProcessImageComponent, SafeHtmlPipe]
})
export class ProcessImageModule {}
